import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { role, userRole as userRoleAPI } from "../../../../api";
import { useDashboardContext } from "../../../../contexts/NewDashboardContext.jsx";
import NormalInput from "../../../../components/form/HorizontalNormalInput/index.jsx";
import NormalSelect from "../../../../components/form/HorizontalNormalSelect/index.jsx";
function ModalChangeUser({ open, onClose, onSubmit, row }) {
  const { selectedApp } = useDashboardContext();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [userRole, setUserRole] = useState("");
  const [status, setStatus] = useState("");
  const [userRoles, setUserRoles] = useState([]);

  async function getUserRole() {
    try {
      let res;
      if (selectedApp == "CGM") {
        res = await userRoleAPI.list();
      }
      if (selectedApp == "CMMS") {
        res = await role.list();
      }

      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setUserRoles(data);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getUserRole();
  }, []);

  function isNumeric(str) {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  }

  async function onSave() {
    //validation
    let errors = [];

    if (!row && !password) {
      errors.push("password");
    }
    if (!email) {
      errors.push("email");
    }
    if (!jobTitle) {
      errors.push("job title");
    }
    if (!firstname) {
      errors.push("first Name");
    }
    if (!lastname) {
      errors.push("last Name");
    }
    // if (!contactNumber) {
    //   errors.push("contact number");
    // } else {
    //   if (!isNumeric(contactNumber)) {
    //     toast.error("Invalid contact number");
    //     return;
    //   }
    // }
    if (!userRole) {
      errors.push("user role");
    }
    if (status === "") {
      errors.push("status");
    }
    if (errors.length > 0) {
      toast.error("The " + errors.join(", ") + " must not be empty");
      return;
    }

    onSubmit({
      password,
      email,
      firstname,
      lastname,
      jobTitle,
      contactNumber,
      userRole,
      status,
    });
    clearFields();
  }

  function clearFields() {
    setPassword("");
    setEmail("");
    setJobTitle("");
    setFirstname("");
    setLastname("");
    setContactNumber("");
    setUserRole("");
    setStatus(1);
  }
  async function handleClose() {
    clearFields();
    onClose();
  }
  function handleRoleChange(e) {
    const value = e.target.value;
    //console.log("selrole", value);
    setUserRole(value);
  }
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
  };
  useEffect(() => {}, []);

  useEffect(() => {
    if (row) {
      setPassword("");
      setEmail(row.email);
      setJobTitle(row.job_title);
      setFirstname(row.firstname);
      setLastname(row.lastname);
      setContactNumber(row.contact_number);
      if (selectedApp == "CMMS") {
        if (row.companies[0].cmms_role?.id) {
          setUserRole(row.companies[0].cmms_role?.id);
        }
      }

      if (selectedApp == "CGM") {
        if (row.companies[0].role?.id) {
          setUserRole(row.companies[0].role?.id);
        }
      }

      setStatus(row.is_active == true ? 1 : 0);
    } else {
      clearFields();
    }
  }, [row]);
  return (
    <ConfirmationDlg
      open={open}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={onSave}
      onClose={handleClose}
    >
      <h4>User</h4>
      <div className="my-2">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
          }}
        >
          <div style={{}}>
            <div style={{ px: 5, py: 4 }}>
              <div style={{ mb: 4 }}>
                <div className={"form-group mb-1"}>
                  <NormalInput
                    label={"Email"}
                    required={true}
                    value={email}
                    type="email"
                    onchange={(e) => {
                      setEmail(e.target.value.toLowerCase());
                    }}
                    name="email"
                  />
                </div>
                <div className={"form-group mb-1"}>
                  <NormalInput
                    label={"First Name"}
                    required={true}
                    value={firstname}
                    onchange={(e) => {
                      setFirstname(e.target.value);
                    }}
                    name="firstname"
                  />
                </div>
                <div className={"form-group mb-1"}>
                  <NormalInput
                    required={true}
                    value={lastname}
                    onchange={(e) => {
                      setLastname(e.target.value);
                    }}
                    name="lastname"
                    label={"Last Name"}
                  />
                </div>
                <div className={"form-group mb-1"}>
                  <NormalInput
                    required={true}
                    value={jobTitle}
                    onchange={(e) => {
                      setJobTitle(e.target.value);
                    }}
                    name="jobtitle"
                    label={"Job Title"}
                  />
                </div>
                <div className={"form-group mb-1"}>
                  <NormalInput
                    required={true}
                    value={password}
                    type="password"
                    onchange={(e) => {
                      setPassword(e.target.value);
                    }}
                    name="password"
                    label={"Password"}
                  />
                </div>
                <div className={"form-group mb-1"}>
                  <NormalSelect
                    label={"User Role"}
                    onchange={handleRoleChange}
                    value={userRole}
                    valueKey={"id"}
                    list={userRoles.map((f) => ({
                      id: f.id,
                      name: f.rolename || f.name,
                    }))}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangeUser;
